import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { WidgetHost, NewsWidget } from '@/core/widgets/export';
import { RouteObject } from 'react-router-dom';
import DataCalendarPage from '@/modules/calendar/pages/calendar/data-calendar-page';
import EventPage from '@/modules/calendar/pages/calendar/event-page';
import AuctionEventPage from '@/modules/calendar/pages/calendar/auction-event-page';
import { selectApi } from '@/modules/calendar/api';
import { isAlphaFlashHost } from '@/shared/theme/export';
import { Permissions } from '@/core/permissions/export';

export class DataCalendarWidget implements NewsWidget {
  defaultTitle = 'HSC';

  readonly id = '/calendar';

  initialize(host: WidgetHost) {}

  async hasPermission(permissions: string[]) {
    const hasSelect = permissions.some(value => Permissions.ANY_SELECT_PRODUCT.test(value));
    const hasExcel = permissions.includes(Permissions.EXCEL_PACKAGE);
    const hasHsc = permissions.includes(Permissions.HSC_PACKAGE);

    return hasSelect && (!hasExcel || hasHsc);
  }

  get headerPanel(): JSX.Element {
    return (
      <>
        <div>
          <FontAwesomeIcon className="align-text-bottom" icon={faCalendar} />{' '}
          {isAlphaFlashHost() ? 'AlphaFlash Select' : 'HSC'}
        </div>
      </>
    );
  }

  headerActions({ children }: { children?: React.ReactNode }): JSX.Element {
    return <>{children}</>;
  }

  get shortTitle(): JSX.Element {
    return (
      <>
        <FontAwesomeIcon icon={faCalendar} />
      </>
    );
  }

  get routes(): RouteObject[] {
    return [
      {
        path: '/:view/:date',
        element: <DataCalendarPage />,
      },
      {
        path: '/event/:id',
        loader: async ({ params }) => {
          try {
            return await selectApi.getEvent(params.id || '');
          } catch (e) {
            return e;
          }
        },
        element: <EventPage />,
      },
      {
        path: '/auction-event/:date/:auctionHolderId',
        loader: async ({ params }) => {
          try {
            const start = parseInt(params.date ?? '-1') - 30_000;
            const end = parseInt(params.date ?? '-1') + 30_000;

            return (await selectApi.getCalendar(start, end)).filter(
              value =>
                value.auction &&
                value.auction.auctionProducts.length > 0 &&
                `${value.auction.auctionProducts[0].auctionHolder.id}` === params.auctionHolderId,
            );
          } catch (e) {
            return e;
          }
        },
        element: <AuctionEventPage />,
      },
    ];
  }

  get defaultRoute(): string {
    return `/daily/today`;
  }
}
